/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "Xn7KWR9EOGQ",
    category: "Stock Investing",
    title:
      "Basics of Stock Market For Beginners Lecture 1 By CA Rachana Phadke Ranade",
    thumbnail: "https://i.ytimg.com/vi/Xn7KWR9EOGQ/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLSA3Tow9_-RTNU6WslhjukZuknVu3JzcGiCMumw5g=s88-c-k-c0x00ffffff-no-rj",
    creator: "CA Rachana Phadke Ranade",
    views: "20663183",
    date: "Feb 12, 2019",
    length: "1:35:07",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "bLl_VRQ7pBs",
    category: "Stock Investing",
    title:
      "Basics of Stock Market For Beginners Lecture 2 By CA Rachana Phadke Ranade",
    thumbnail: "https://i.ytimg.com/vi/bLl_VRQ7pBs/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLSA3Tow9_-RTNU6WslhjukZuknVu3JzcGiCMumw5g=s88-c-k-c0x00ffffff-no-rj",
    creator: "CA Rachana Phadke Ranade",
    views: "7929023",
    date: "Jun 1, 2019",
    length: "1:43:02",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "hBKqk5oYexw",
    category: "Stock Investing",
    title:
      "Basics Of Stock Market for Beginners Lecture 3 by CA Rachana Ranade",
    thumbnail: "https://i.ytimg.com/vi/hBKqk5oYexw/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLSA3Tow9_-RTNU6WslhjukZuknVu3JzcGiCMumw5g=s88-c-k-c0x00ffffff-no-rj",
    creator: "CA Rachana Phadke Ranade",
    views: "2602507",
    date: "Jul 25, 2020",
    length: "1:31:12",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "hIYSxqrraWA",
    category: "Stock Investing",
    title:
      "Stock Market for Beginners | Investing Strategies 2021 | Ankur Warikoo Hindi",
    thumbnail: "https://i.ytimg.com/vi/hIYSxqrraWA/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "539344",
    date: "Dec 22, 2020",
    length: "19:33",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "nmjbzn1eKuM",
    category: "Stock Investing",
    title:
      "Stock Analysis For beginners | Share Market Investing explained! | Ankur Warikoo Hindi Video",
    thumbnail: "https://i.ytimg.com/vi/nmjbzn1eKuM/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "352370",
    date: "Mar 16, 2021",
    length: "17:53",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "VtYE9FkcJlU",
    category: "Real Estate",
    title:
      "Rich Dad Wealth Machine: How to Invest in Real Estate to Maximize Cash Flow - Robert Kiyosaki",
    thumbnail: "https://i.ytimg.com/vi/VtYE9FkcJlU/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLSOjQxuPE0N5nm0DKC2AR3HCizngU8NdLPOm83zRQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "The Rich Dad Channel",
    views: "400248",
    date: "Jan 21, 2020",
    length: "43:06",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "7_15RfVrxec",
    category: "Real Estate",
    title:
      "What Type of Real Estate the Rich Invest In - Robert Kiyosaki [FULL Radio Show]",
    thumbnail: "https://i.ytimg.com/vi/7_15RfVrxec/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLSOjQxuPE0N5nm0DKC2AR3HCizngU8NdLPOm83zRQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "The Rich Dad Channel",
    views: "910823",
    date: "Aug 7, 2019",
    length: "47:24",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "yNaN5kYTNLY",
    category: "Basic Finance",
    title:
      "Complete Financial Planning for your 20s! | Investing for Beginners 2021 | Ankur Warikoo Hindi",
    thumbnail: "https://i.ytimg.com/vi/yNaN5kYTNLY/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "2650815",
    date: "Jan 19, 2021",
    length: "19:12",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "XKhizGVv80s",
    category: "Basic Finance",
    title:
      "ESOP - Employee Stock Option Plan EXPLAINED in Hindi | Ankur Warikoo Startups | Startup Video",
    thumbnail: "https://i.ytimg.com/vi/XKhizGVv80s/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "244302",
    date: "Jan 9, 2021",
    length: "16:30",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "nbrkmJTuGoY",
    category: "Basic Finance",
    title:
      "Best Personal Finance strategies for 2021 | How to manage your money | Ankur Warikoo Hindi",
    thumbnail: "https://i.ytimg.com/vi/nbrkmJTuGoY/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "184621",
    date: "Apr 17, 2021",
    length: "14:04",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "LIItg5G7PzQ",
    category: "Basic Finance",
    title: "How I SPEND MY MONEY? | Personal Finance | Ankur Warikoo Hindi",
    thumbnail: "https://i.ytimg.com/vi/LIItg5G7PzQ/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "155322",
    date: "Feb 24, 2022",
    length: "22:14",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "TITs-R1BM-M",
    category: "Basic Finance",
    title:
      "3 money management tips | Best Personal Finance Strategies | Ankur Warikoo Hindi Video",
    thumbnail: "https://i.ytimg.com/vi/TITs-R1BM-M/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "59285",
    date: "Oct 24, 2020",
    length: "7:07",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "zL3CniOFMvU",
    category: "Basic Finance",
    title:
      "7 ASSETS that WILL make you RICH! | Personal Finance for Beginners | Ankur Warikoo Hindi",
    thumbnail: "https://i.ytimg.com/vi/zL3CniOFMvU/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/X9eoDIB9cgb1s-kvATRs1lQDcU4Fjc15NDV9s9FF8ck7IsA8u7OdijaernoDV9LLdePgjlt_=s88-c-k-c0x00ffffff-no-rj",
    creator: "warikoo",
    views: "290492",
    date: "Mar 12, 2022",
    length: "18:59",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "mSB8wMHxHKs",
    category: "Self Help",
    title: "Financial Freedom - By Sandeep Maheshwari",
    thumbnail: "https://i.ytimg.com/vi/mSB8wMHxHKs/hq720.jpg",
    profile:
      "https://yt3.ggpht.com/UjKc54x7sVzQ4KLlS5rgMI0DdLoaa4cFbFpsFsxLxcSXEbTWotIPvyCA63BjTddipDv8LQufiQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "Sandeep Maheshwari",
    views: "1933520",
    date: "Jul 5, 2021",
    length: "1:14:04",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "LknADkbbekc",
    category: "Self Help",
    title: "Make Money From Money - Sandeep Maheshwari",
    thumbnail:
      "https://i.ytimg.com/vi/LknADkbbekc/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLByYqNqV9LA9xHIF4dt3vClsn76Cg",
    profile:
      "https://yt3.ggpht.com/UjKc54x7sVzQ4KLlS5rgMI0DdLoaa4cFbFpsFsxLxcSXEbTWotIPvyCA63BjTddipDv8LQufiQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "Sandeep Maheshwari",
    views: "44175676",
    date: "Sep 25, 2019",
    length: "28:25",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: "4WXiyQOGuk4",
    category: "Self Help",
    title:
      "How To Start Your Own Business? Q&A #2 With Sandeep Maheshwari | Startup & Entrepreneurship | Hindi",
    thumbnail:
      "https://i.ytimg.com/vi/4WXiyQOGuk4/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAhbFmqtdd3e-lZQYkWlTqBR0KoUw",
    profile:
      "https://yt3.ggpht.com/UjKc54x7sVzQ4KLlS5rgMI0DdLoaa4cFbFpsFsxLxcSXEbTWotIPvyCA63BjTddipDv8LQufiQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "Sandeep Maheshwari",
    views: "1700158 ",
    date: "Mar 16, 2021",
    length: "39:45",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
];
